import { BaseContainerModel } from '../base-container.model';
import { bl_wms_item_hdr_RowInterface, bl_wms_item_hdr_RowClass } from '../../dbschema/index';

export class WmsItemHdrContainer extends BaseContainerModel {
    bl_wms_item_hdr: bl_wms_item_hdr_RowInterface = new bl_wms_item_hdr_RowClass();
}
